import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const baseURL = process.env.REACT_APP_BASE_URL;

export const createSubcodeAction = createAsyncThunk(
  "subcode/create",
  async (info, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;

      const config = {
        headers: {
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.post(
        `${baseURL}/api/subcode`,
        {
          name: info?.name,
          code: info?.code,
          subcode: info?.subcode,
        },
        config
      );
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchSubCodesAction = createAsyncThunk(
  "subcode/fetch",
  async (info, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;

      const config = {
        headers: {
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.get(
        `${baseURL}/api/subcode`,

        config
      );
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getSubCodeAction = createAsyncThunk(
  "subcode/get",

  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };

      const { data } = await axios.get(`${baseURL}/api/subcode/${id}`, config);
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSubCodeAction = createAsyncThunk(
  "subcode/update",

  async (info, { rejectWithValue, getState, dispatch }) => {
    try {
      const user = getState()?.users;
      const { userAuth } = user;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseURL}/api/subcode/${info.id}`,
        {
          name: info?.name,
          code: info?.code,
          subcode: info?.subcode,
        },
        config
      );
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteSubCodeAction = createAsyncThunk(
  "subcode/delete",

  async (id, { rejectWithValue, getState, dispatch }) => {
    const info = getState();
    const user = getState()?.users;
    const { userAuth } = user;
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${userAuth?.token}`,
        },
      };
      const { data } = await axios.delete(
        `${baseURL}/api/subcode/${id}`,
        config
      );
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

const SubcodeSlices = createSlice({
  name: "subcode",
  initialState: {},
  extraReducers: (builder) => {
    builder.addCase(createSubcodeAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(createSubcodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.subcode = action?.payload;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(createSubcodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload.message;
      state.serverErr = action?.error?.message;
    });
    builder.addCase(fetchSubCodesAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchSubCodesAction.fulfilled, (state, action) => {
      state.loading = false;
      state.subcodes = action?.payload;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(fetchSubCodesAction.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload.message;
      state.serverErr = action?.error?.message;
    });

    //Get   By Id
    builder.addCase(getSubCodeAction.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getSubCodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.getSubCode = action?.payload;

      state.appError = undefined;
      state.serverError = undefined;
    });

    builder.addCase(getSubCodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appError = action?.payload?.message;
      state.serverError = action?.error?.message;
    });

    //Update   By Id
    builder.addCase(updateSubCodeAction.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(updateSubCodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.updateSubCode = action?.payload;

      state.appError = undefined;
      state.serverError = undefined;
    });

    builder.addCase(updateSubCodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appError = action?.payload?.message;
      state.serverError = action?.error?.message;
    });

    //Delete
    builder.addCase(deleteSubCodeAction.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(deleteSubCodeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteSubCode = action?.payload;

      state.appError = undefined;
      state.serverError = undefined;
    });

    builder.addCase(deleteSubCodeAction.rejected, (state, action) => {
      state.loading = false;
      state.appError = action?.payload?.message;
      state.serverError = action?.error?.message;
    });
  },
});

export default SubcodeSlices.reducer;
